import styled from "styled-components";

export const Container = styled.div`
  right: 0rem;
  background-color: white;
  top: 3.2rem;
  position: absolute;
  height: ${(props) => (props.active ? "fit-content" : "0rem")};
  max-height: ${(props) => (props.active ? "20rem" : "0rem")};
  width: 22rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  transition: 0.2s ease-in-out !important;
  z-index: 1;

  font-size: 0.8rem;
  font-weight: 500;

  ::-webkit-scrollbar {
    border-radius: 10px;
    width: 0.6rem;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #aaa;
  }

  ::-webkit-scrollbar-thumb:hover {
    border-radius: 10px;
    background: #555;
  }

  -webkit-box-shadow: 0px 0px 50px -18px rgba(0, 0, 0, 1);
  -moz-box-shadow: 0px 0px 50px -18px rgba(0, 0, 0, 1);
  box-shadow: 0px 0px 50px -18px rgba(0, 0, 0, 1);

  @media screen and (max-width: 1100px) {
    right: 7rem;
  }
`;

export const Notification = styled.div`
  height: auto !important;
  width: 100% !important;
  border: 0.1rem white solid;
  padding: 1rem !important;
  background-color: ${(props) => (props.active ? "#aaa" : "#fff")};
  color: #000;
  display: flex;
  flex-direction: row;
  transition: 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) => (props.active ? "#999" : "#ddd")};
  }
`;

export const NotificationIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 2rem !important;
    width: 2rem !important;
  }
`;
export const NotificationDescription = styled.div`
  padding-left: 1rem !important;
`;
export const NotificationButton = styled.button`
  padding: 1rem;
  border: 0.5rem white solid;
  border-radius: 16px;
  background-color: #333;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s ease-in-out;

  span {
    padding-left: 0.5rem;
  }

  &:hover {
    background-color: #555;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.6rem;
  font-weight: 600;
  align-items: center;
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.6rem;
  font-weight: 600;
  width: 100%;
  text-align: right;
`;
